import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Chip, img, fmt } from "./kit";

/// 5 Kas: Inceleme — bir kullanicinin mesaj gecmisi ve 1v1 (arama/eslesme) analizi. Yalniz okuma.
const zaman = (d) =>
  d ? new Date(d).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";
const sure = (s) => {
  s = Math.round(Number(s) || 0);
  if (!s) return "0 sn";
  const d = Math.floor(s / 60);
  return d ? `${d} dk ${s % 60} sn` : `${s} sn`;
};

const Avatar = ({ p, size = 32 }) => (
  <img
    src={img(p?.image)}
    alt=""
    onError={(e) => (e.target.style.visibility = "hidden")}
    style={{ width: size, height: size, borderRadius: "50%", objectFit: "cover", background: "#E5E7EB", flex: "none" }}
  />
);
const Kisi = ({ p }) => (
  <div className="d-flex align-items-center" style={{ gap: 8, minWidth: 0 }}>
    <Avatar p={p} />
    <div style={{ minWidth: 0 }}>
      <div style={{ fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{p?.name || "—"}</div>
      <div style={{ fontSize: 12, color: "#6B7280" }}>
        {p?.uid || ""} {p?.host ? "· yayıncı" : ""} {p?.gender ? `· ${/^f/i.test(p.gender) ? "Kadın" : "Erkek"}` : ""}
      </div>
    </div>
  </div>
);

const TUR = { 0: "Resim", 1: "Video", 2: "Ses", 3: "Yazı", 4: "Hediye / emoji", 5: "Arama", 6: "Zarf" };

const Mesajlar = ({ topic, me, onBack }) => {
  const [rows, setRows] = useState(null);
  const [more, setMore] = useState(false);
  const load = useCallback(
    async (before) => {
      const r = await api.incMesajlar(topic.topicId, before);
      if (!r?.status) return setRows([]);
      setRows((old) => (before ? [...r.rows, ...(old || [])] : r.rows));
      setMore(r.more);
    },
    [topic.topicId]
  );
  useEffect(() => {
    load();
  }, [load]);
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 12, flexWrap: "wrap" }}>
          <button className="btn btn-light btn-sm" onClick={onBack}>← Sohbetler</button>
          <Kisi p={me} /> <span style={{ color: "#9CA3AF" }}>↔</span> <Kisi p={topic.other} />
          <span style={{ marginLeft: "auto", fontSize: 13, color: "#6B7280" }}>
            {fmt(topic.total)} mesaj · gönderdi {fmt(topic.sent)} · aldı {fmt(topic.received)} · ücretli {fmt(topic.paid)}
          </span>
        </div>
        {more && (
          <div style={{ textAlign: "center", marginBottom: 10 }}>
            <button className="btn btn-light btn-sm" onClick={() => load(rows?.[0]?.at)}>Daha eski mesajlar</button>
          </div>
        )}
        {!rows ? (
          <div className="badu-empty">Yükleniyor…</div>
        ) : !rows.length ? (
          <div className="badu-empty">Mesaj yok.</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 6, maxHeight: "70vh", overflowY: "auto", padding: 4 }}>
            {rows.map((m) => {
              const benim = me?.id && (m.from?.id === me.id || (topic.myIds || []).includes(m.from?.id));
              return (
                <div key={m.id} style={{ alignSelf: benim ? "flex-end" : "flex-start", maxWidth: "75%" }}>
                  <div
                    style={{
                      background: benim ? "#EEF2FF" : "#F3F4F6",
                      border: "1px solid #E5E7EB",
                      borderRadius: 12,
                      padding: "6px 10px",
                      wordBreak: "break-word",
                    }}
                  >
                    {m.type === 3 && <div style={{ whiteSpace: "pre-wrap" }}>{m.text}</div>}
                    {m.type === 0 && m.image && (
                      <a href={img(m.image)} target="_blank" rel="noreferrer">
                        <img src={img(m.image)} alt="" style={{ maxWidth: 220, maxHeight: 220, borderRadius: 8 }} />
                      </a>
                    )}
                    {m.type === 1 && m.video && <video src={img(m.video)} controls style={{ maxWidth: 260, borderRadius: 8 }} />}
                    {m.type === 2 && m.audio && <audio src={img(m.audio)} controls />}
                    {m.type === 4 && (
                      <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        {m.image ? <img src={img(m.image)} alt="" style={{ width: 48, height: 48, objectFit: "contain" }} /> : null}
                        <span>{m.text || TUR[4]}</span>
                      </div>
                    )}
                    {m.type === 5 && <div>📞 Arama {m.callType === 1 ? "· cevaplandı" : m.callType === 2 ? "· reddedildi" : m.callType === 3 ? "· cevapsız" : ""} {m.callDuration && m.callDuration !== "00:00:00" ? `· ${m.callDuration}` : ""}</div>}
                    {m.type === 6 && <div>🧧 Zarf {m.text}</div>}
                    {![0, 1, 2, 3, 4, 5, 6].includes(m.type) && <div>{m.text || "—"}</div>}
                  </div>
                  <div style={{ fontSize: 11, color: "#9CA3AF", textAlign: benim ? "right" : "left", marginTop: 2 }}>
                    {m.from?.name || ""} · {zaman(m.at)} {m.paid ? `· ${fmt(m.paid.price)} coin` : ""} {benim && m.isRead ? "· okundu" : ""}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

const SohbetSekmesi = ({ q }) => {
  const [data, setData] = useState(null);
  const [acik, setAcik] = useState(null);
  const [filtre, setFiltre] = useState("");
  useEffect(() => {
    setAcik(null);
    if (!q) return setData(null);
    setData({ yukleniyor: true });
    api.incSohbetler(q).then((r) => setData(r?.status ? r : { hata: r?.message || "Bulunamadı" }));
  }, [q]);
  if (!data) return <div className="badu-empty">Kullanıcı ID yaz ve Ara'ya bas.</div>;
  if (data.yukleniyor) return <div className="badu-empty">Yükleniyor…</div>;
  if (data.hata) return <div className="badu-empty">{data.hata}</div>;
  if (acik) return <Mesajlar topic={{ ...acik, myIds: data.ids }} me={data.user} onBack={() => setAcik(null)} />;
  const f = filtre.trim().toLowerCase();
  const rows = data.rows.filter((r) => !f || `${r.other?.name} ${r.other?.uid}`.toLowerCase().includes(f));
  const top = data.rows.reduce((a, r) => ({ n: a.n + r.total, s: a.s + r.sent, p: a.p + r.paid }), { n: 0, s: 0, p: 0 });
  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center" style={{ gap: 12, flexWrap: "wrap", marginBottom: 10 }}>
          <Kisi p={data.user} />
          <Chip kind="info">{fmt(data.rows.length)} sohbet</Chip>
          <Chip kind="info">{fmt(top.n)} mesaj</Chip>
          <Chip kind="ok">gönderdi {fmt(top.s)}</Chip>
          <Chip kind="wait">ücretli {fmt(top.p)}</Chip>
          <input className="form-control" style={{ maxWidth: 220, marginLeft: "auto" }} placeholder="Kişi ara" value={filtre} onChange={(e) => setFiltre(e.target.value)} />
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Kişi</th>
                <th>Toplam</th>
                <th>Gönderdi</th>
                <th>Aldı</th>
                <th>Ücretli</th>
                <th>Son mesaj</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.topicId}>
                  <td><Kisi p={r.other} /></td>
                  <td>{fmt(r.total)}</td>
                  <td>{fmt(r.sent)}</td>
                  <td>{fmt(r.received)}</td>
                  <td>{fmt(r.paid)}</td>
                  <td>{zaman(r.last)}</td>
                  <td><button className="btn btn-primary btn-sm" onClick={() => setAcik(r)}>Mesajları aç</button></td>
                </tr>
              ))}
              {!rows.length && (
                <tr><td colSpan={7}><div className="badu-empty">Sohbet yok.</div></td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const AramaSekmesi = ({ q }) => {
  const [days, setDays] = useState(30);
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!q) return setData(null);
    setData({ yukleniyor: true });
    api.incAramalar(q, days).then((r) => setData(r?.status ? r : { hata: r?.message || "Bulunamadı" }));
  }, [q, days]);
  if (!data) return <div className="badu-empty">Kullanıcı ID yaz ve Ara'ya bas.</div>;
  if (data.yukleniyor) return <div className="badu-empty">Yükleniyor…</div>;
  if (data.hata) return <div className="badu-empty">{data.hata}</div>;
  const t = data.total;
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="d-flex align-items-center" style={{ gap: 12, flexWrap: "wrap" }}>
            <Kisi p={data.user} />
            <select className="form-control" style={{ maxWidth: 140 }} value={days} onChange={(e) => setDays(Number(e.target.value))}>
              {[1, 7, 30, 90, 365].map((d) => (
                <option key={d} value={d}>Son {d} gün</option>
              ))}
            </select>
            <Chip kind="info">{fmt(t.n)} arama</Chip>
            <Chip kind="ok">{fmt(t.connected)} bağlandı</Chip>
            <Chip kind="info">{sure(t.seconds)}</Chip>
            <Chip kind="wait">{fmt(t.coin)} coin</Chip>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h6 style={{ fontWeight: 700 }}>Kişi bazında</h6>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr><th>Kişi</th><th>Arama</th><th>Bağlanan</th><th>Toplam süre</th><th>Coin</th></tr>
              </thead>
              <tbody>
                {data.people.map((p, i) => (
                  <tr key={i}>
                    <td><Kisi p={p.other} /></td>
                    <td>{fmt(p.n)}</td>
                    <td>{fmt(p.connected)}</td>
                    <td>{sure(p.seconds)}</td>
                    <td>{fmt(p.coin)}</td>
                  </tr>
                ))}
                {!data.people.length && <tr><td colSpan={5}><div className="badu-empty">Bu dönemde arama yok.</div></td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <h6 style={{ fontWeight: 700 }}>Tüm aramalar (son 500)</h6>
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr><th>Tarih</th><th>Kişi</th><th>Tür</th><th>Rol</th><th>Durum</th><th>Süre</th><th>Coin</th></tr>
              </thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr key={r.id}>
                    <td>{zaman(r.at)}</td>
                    <td><Kisi p={r.other} /></td>
                    <td>{r.kind === "eslesme" ? "Eşleşme" : "Özel arama"} · {r.media === "audio" ? "Sesli" : "Görüntülü"}</td>
                    <td>{r.role === "user" ? "Ödeyen" : "Kazanan"}</td>
                    <td>{r.connected ? <Chip kind="ok">Bağlandı</Chip> : <Chip kind="wait">Bağlanmadı</Chip>}</td>
                    <td>{sure(r.duration)}</td>
                    <td>{fmt(r.coin)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

/// 5 Kas: yayinciyi baska ajansa tasima
const TransferSekmesi = () => {
  const [host, setHost] = useState("");
  const [ajans, setAjans] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const gonder = async (e) => {
    e.preventDefault();
    if (!host.trim() || !ajans.trim()) return setMsg("Yayıncı ID ve ajans kodu gerekli.");
    if (!window.confirm(`${host} ID'li yayıncı ${ajans} ajansına taşınsın mı? Eski ajansından çıkarılır.`)) return;
    setBusy(true);
    const r = await api.incTransfer(host.trim(), ajans.trim());
    setBusy(false);
    setMsg(r?.message || (r?.status ? "Taşındı." : "Yapılamadı"));
  };
  return (
    <div className="card">
      <div className="card-body">
        <h6 style={{ fontWeight: 700 }}>Yayıncıyı başka ajansa taşı</h6>
        <form className="d-flex" style={{ gap: 8, flexWrap: "wrap" }} onSubmit={gonder}>
          <input className="form-control" style={{ maxWidth: 200 }} placeholder="Yayıncı ID" value={host} onChange={(e) => setHost(e.target.value)} />
          <input className="form-control" style={{ maxWidth: 220 }} placeholder="Hedef ajans kodu" value={ajans} onChange={(e) => setAjans(e.target.value)} />
          <button className="btn btn-primary btn-sm" disabled={busy} type="submit">{busy ? "Taşınıyor…" : "Taşı"}</button>
        </form>
        {msg && <div style={{ marginTop: 10 }}><Chip kind="info">{msg}</Chip></div>}
        <div style={{ fontSize: 12, color: "#6B7280", marginTop: 8 }}>Yayıncının eski ajans bağı kaldırılır, yeni ajansa aktif üye olarak eklenir. Geçmiş kazançlar eski ajansta kalır. İşlem admin kaydına yazılır.</div>
      </div>
    </div>
  );
};

const Inceleme = () => {
  const [tab, setTab] = useState("mesaj");
  const [giris, setGiris] = useState("");
  const [q, setQ] = useState("");
  return (
    <div className="mainDashboard">
      <PageHead title="İnceleme" sub="Mesaj geçmişi, birebir arama/eşleşme analizi ve yayıncı transferi" />
      <div className="card">
        <div className="card-body d-flex align-items-center" style={{ gap: 10, flexWrap: "wrap" }}>
          <div className="btn-group">
            <button className={`btn btn-sm ${tab === "mesaj" ? "btn-primary" : "btn-light"}`} onClick={() => setTab("mesaj")}>Mesaj geçmişi</button>
            <button className={`btn btn-sm ${tab === "arama" ? "btn-primary" : "btn-light"}`} onClick={() => setTab("arama")}>1v1 analiz</button>
            <button className={`btn btn-sm ${tab === "transfer" ? "btn-primary" : "btn-light"}`} onClick={() => setTab("transfer")}>Transfer</button>
          </div>
          <form
            className="d-flex"
            style={{ gap: 8, marginLeft: "auto" }}
            onSubmit={(e) => {
              e.preventDefault();
              setQ(giris.trim());
            }}
          >
            <input className="form-control" style={{ width: 200 }} placeholder="Kullanıcı ID" value={giris} onChange={(e) => setGiris(e.target.value)} />
            <button className="btn btn-primary btn-sm" type="submit">Ara</button>
          </form>
        </div>
      </div>
      {tab === "mesaj" ? <SohbetSekmesi q={q} /> : tab === "arama" ? <AramaSekmesi q={q} /> : <TransferSekmesi />}
    </div>
  );
};

export default Inceleme;
